import { useCallback } from 'react'

import { switchWalletChain } from '@/lib/wallet/connect'
import { signTypedDataV4 } from '@/lib/wallet/sign-typed-data'
import { papertradeConfirmSessionKey, papertradePrepareSessionKey } from '@/service/venue.api'

export function usePapertradeOnboard() {
  // Prepare, move the wallet to the chain the response names, then sign the
  // typed data verbatim. `preparedAt` lets the caller track the backend's
  // PREPARE_WINDOW_MS. walletAddress must already be connected.
  const prepareAndSign = useCallback(
    async (
      accountId: string,
      wallet: string
    ): Promise<{ signature: string; preparedAt: number }> => {
      const prepared = await papertradePrepareSessionKey({ accountId, walletAddress: wallet })
      const preparedAt = Date.now()
      await switchWalletChain(Number(prepared.chainId))
      const signature = await signTypedDataV4(wallet, prepared.typedDataJson)
      return { signature, preparedAt }
    },
    []
  )

  const confirm = useCallback(
    async (accountId: string, wallet: string, signature: string): Promise<void> => {
      await papertradeConfirmSessionKey({ accountId, walletAddress: wallet, signature })
    },
    []
  )

  return { prepareAndSign, confirm }
}
